import fetchJsonp from "fetch-jsonp";
// import { API } from "../constant";
import colorApi from './color.js'
import {
  IOrgInfo,
  GoodsParams,
  PizhuanParams,
  ChuzhiNoticeParams,
  IGood,
  ILocation,
  IOrgs,
  IResponse,
  OrgsParams,
  RecommendParams,
  NoticeParams,
  MechanismSelectionParams,
  IShopNoticeList,
  IMechanismSelectionList,
} from "./interface";

const CB = { jsonpCallback: "jsonp" }
const API = process.env.REACT_APP_API_URL + '/api?loginType=3'

// https://cf.jd.com/pages/viewpage.action?pageId=177379023

export function getOrgInfo(vendorId: Number): Promise<IOrgInfo> {
  let params = {
    vendorId: vendorId,
    addSearchHistoryFlag: false, // 是否添加查询历史
    productFlag: false, // 是否带机构下的拍品，默认true
  }
  return colorApi('paimai_getShopOrganizationInfo', params).then((res: any) => {
      const { data, message, statusCode } = res;
      if (statusCode === 200 && data) {
        return data;
      } 
      console.log('getOrgInfo', message);
      return {}
  })
}

export function getRecommend(params: RecommendParams): Promise<IResponse> {
  return fetchJsonp(`${API}&appid=AuctionTreasure&functionId=listByCondi&body=${JSON.stringify(params)}`, CB)
    .then(response => response.json())
    .then(res => {
      const { code, data, msg } = res;
      if (code === "0000" && data) {
        return data;
      } 
      console.log('getRecommend', msg);
      return {}
    });
}

export function getGoods(params: GoodsParams): Promise<IResponse> {
  // https://cf.jd.com/pages/viewpage.action?pageId=420668911
  let body = Object.assign({
    reqSource: 0,                     // 请求来源
    pageViewSource:'page_shop_pc' //此字段用来标识当前页面需要显示单轮报价拍品
  }, params)
  return colorApi('paimai_unifiedSearch', body).then((res: any) => { 
    let { message = '', statusCode = 0 } = res || {}
    if(statusCode === 200){
      return res
    }
    // console.log('getGoods', message)
    return {}
  })
}

export function getPizhuanList(params: PizhuanParams): Promise<IResponse> {
  // https://cf.jd.com/pages/viewpage.action?pageId=849318712
  return fetchJsonp(`${API}&appid=paimai&functionId=innovateman_queryTenderProjectList&body=${JSON.stringify(params)}`,CB)
    .then(response => response.json())
    .then(res => {
      let { message = '', statusCode = 0 } = res || {}
      if(statusCode === 200){
        return res
      }
      return {}
    });
}

export function updatePizhuan(params: PizhuanParams): Promise<IResponse> {
  // https://cf.jd.com/pages/viewpage.action?pageId=849318712
  return fetchJsonp(`${API}&appid=paimai&functionId=innovateman_queryProjectRealTimeData&body=${JSON.stringify(params)}`,CB)
    .then(response => response.json())
    .then(res => {
      let { message = '', statusCode = 0 } = res || {}
      if(statusCode === 200){
        return res
      }
      return {}
    }).catch(err => {
      console.log(err)
    });
}

export function getChuzhiNoticeList(params: ChuzhiNoticeParams): Promise<IResponse> {
  // https://joyspace.jd.com/pages/2VeesSmAbBSim7jSuaLp
  return fetchJsonp(`${API}&appid=pmmall-pc&functionId=paimai_disposalAnnouncementData&body=${JSON.stringify(params)}`,CB)
    .then(response => response.json())
    .then(res => {
      let { message = '', statusCode = 0 } = res || {}
      if(statusCode === 200){
        return res
      }
      return {}
    });
}

const dataHandler = (res: any) => {
  if(res.code === 0){
    return res
  }
  console.log('res:', res)
  // const { data, message, resultCode } = res;
  // if (resultCode === "0000") {
  //   if (data) {
  //     return data;
  //   } else {
  //     console.log("接口返回成功，但无数据");
  //   }
  // } else {
  //   console.log(message);
  // }
};


export function getOrgs(params: OrgsParams): Promise<IOrgs[]> {
  return fetchJsonp(`${API}&appid=paimai&functionId=getOrganizationIndexData&body=${JSON.stringify(params)}`,CB)
    .then(response => response.json())
    .then(dataHandler);
}

export function getGoodStatus(ids: Number[]): Promise<IGood[]> {
  //http://beta-api.m.jd.com/api?appid=paimai&functionId=getPaimaiCurrentInfoByIdsForApi&body={%22ids%22:[167644092,167674545],%22idType%22:0,%22clientInfo%22:{%22businessId%22:1001
  let params = {
    ids: ids,
    idType: 0,
    clientInfo:{ businessId: 'shop_public'}
  }
  return colorApi('getPaimaiCurrentInfoByIdsForApi',params).then((res: any) => {
    let { message = '', statusCode = 0 } = res || {}
        if(statusCode === 200){
          return res.data
        }
        console.log('getGoodStatus', message)
        return {}
      });
}

export function getLocationById(id: number): Promise<ILocation[]> {
  return fetchJsonp(`//fts.jd.com/area/get?fid=${id}`)
    .then(response => response.json());
}

export function getLiveInfoByVendorId(params: object): Promise<{}> {
  return fetchJsonp(`${API}&appid=paimai&functionId=getLiveInfoByVendorId&body=${JSON.stringify(params)}`,CB)
    .then(response => response.json())
    .then(dataHandler);
}

export function getShopNoticeList(params: NoticeParams): Promise<IShopNoticeList> {
  return fetchJsonp(`${API}&appid=paimai&functionId=paimai_getShopNoticeList&body=${JSON.stringify(params)}`, CB)
    .then(response => response.json())
    .then(res => {
      const { code, data } = res;
      if (code===0 && data.length>0 ) {
        return res;
      } 
      return {}
    });
}

export function getMechanismSelectionList(params: MechanismSelectionParams): Promise<IMechanismSelectionList> {
  return fetchJsonp(`${API}&appid=AuctionTreasure&functionId=listAnnouncementByCondi&body=${JSON.stringify(params)}`, CB)
    .then(response => response.json())
    .then(res => {
      const { code, data } = res;
      if (code === "0000" && data) {
        return data;
      } 
      return {}
    });
}

export function getCustomSearchCategory(params: {}): Promise<[]> {
  return fetchJsonp(`${API}&appid=paimai&functionId=paimai_getCustomSearchCategory&body=${JSON.stringify(params)}`, CB)
    .then(response => response.json())
    .then(res => {
      const { code, datas } = res;
      if (code===0 && datas.length>0 ) {
        return datas;
      } 
      return {}
    });
}

export function getIsFollow(params: any): Promise<any> {
  return fetchJsonp(`${API}&appid=paimai&functionId=paimai_isFollow&body=${JSON.stringify(params)}`, CB)
    .then(response => response.json())
    .then(res => {
      const { data } = res;
      return data
    });
}

export function follow(params: any): Promise<any> {
  return fetchJsonp(`${API}&appid=paimai&functionId=follow&body=${JSON.stringify(params)}`, CB)
    .then(response => response.json())
    .then(res => {
      return res
    });
}

export function unFollow(params: any): Promise<any> {
  return fetchJsonp(`${API}&appid=paimai&functionId=unFollow&body=${JSON.stringify(params)}`, CB)
    .then(response => response.json())
    .then(res => {
      return res
    });
}


export function getAdData(params: any): Promise<any> {
  return fetchJsonp(`${API}&appid=paimai&functionId=getOrgOrVendorAdData&body=${JSON.stringify(params)}`, CB)
    .then(response => response.json())
    .then(res => {
      return res
    });
}